import { createMultiStyleConfigHelpers, type StyleFunctionProps } from "@chakra-ui/react";
import { alertAnatomy } from "@chakra-ui/anatomy";

const helpers = createMultiStyleConfigHelpers(alertAnatomy.keys);

const statusToTone: Record<string, string> = {
  success: "success",
  warning: "warning",
  error: "danger",
  info: "info",
  loading: "info",
};

/**
 * Alert / Toast variant `soft` (DEFAULT): subtle status background, status-coloured 3px left rail, radius md.
 * Toasts pick this up through ChakraProvider toastOptions (App.tsx).
 */
export const Alert = helpers.defineMultiStyleConfig({
  variants: {
    soft: (props: StyleFunctionProps) => {
      const t = statusToTone[props.status ?? "info"] ?? "neutral";
      return {
        container: {
          bg: `status.${t}.bg`,
          color: `status.${t}.fg`,
          borderRadius: "md",
          borderLeft: "3px solid",
          borderLeftColor: `status.${t}.solid`,
          px: 4,
          py: 3,
          alignItems: "flex-start",
          boxShadow: "none",
        },
        icon: { color: `status.${t}.solid`, w: 5, h: 5, mt: 0.5 },
        spinner: { color: `status.${t}.solid` },
        title: { fontWeight: 700, fontSize: "0.875rem", lineHeight: 1.4 },
        description: { fontSize: "0.8125rem", fontWeight: 500, lineHeight: 1.5 },
      };
    },
  },
  defaultProps: { variant: "soft" },
});
